module.exports = __webpack_public_path__ + "static/media/ic_starInRound.41576d0c.svg";